(function () {
    'use strict';

    function initDescriptionTabs() {
        var tabContainer = document.getElementById('jd-description-tabs');
        if (!tabContainer) {
            return;
        }

        var tabs = tabContainer.querySelectorAll('.jd-description-tab');

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                document.querySelectorAll('.jd-description-panel').forEach(function (panel) {
                    panel.classList.add('jd-hidden');
                });
                tabs.forEach(function (other) {
                    other.classList.remove('active');
                });

                var panel = document.getElementById(tab.dataset.tab);
                if (panel) {
                    panel.classList.remove('jd-hidden');
                }
                tab.classList.add('active');
            });
        });
    }

    function initSourceToggles() {
        document.querySelectorAll('.jd-toggle-source').forEach(function (button) {
            button.addEventListener('click', function () {
                var source = document.getElementById(button.dataset.sourceTarget);
                if (!source) {
                    return;
                }

                var isHidden = source.classList.toggle('jd-hidden');
                button.innerHTML = isHidden
                    ? '<i class="fa fa-code"></i> View HTML Source'
                    : '<i class="fa fa-code"></i> Hide HTML Source';
            });
        });
    }

    function initUnchangedToggle() {
        var button = document.getElementById('jd-show-unchanged');
        var comparison = document.getElementById('jd-comparison');
        if (!button || !comparison) {
            return;
        }

        button.addEventListener('click', function () {
            var unchangedRows = comparison.querySelectorAll('.jd-row-unchanged');
            var showing = unchangedRows.length > 0 && unchangedRows[0].classList.contains('jd-hidden');

            unchangedRows.forEach(function (row) {
                row.classList.toggle('jd-hidden', !showing);
            });

            button.innerHTML = showing
                ? '<i class="fa fa-eye-slash"></i> Hide Unchanged Fields'
                : '<i class="fa fa-eye"></i> Show Unchanged Fields';
        });
    }

    function initCopyButtons() {
        document.querySelectorAll('.jd-copy-button').forEach(function (button) {
            button.addEventListener('click', function () {
                var target = document.getElementById(button.dataset.copyTarget);
                if (!target || !navigator.clipboard) {
                    return;
                }

                navigator.clipboard.writeText(target.textContent.trim()).then(function () {
                    var icon = button.querySelector('i');
                    if (!icon) {
                        return;
                    }
                    icon.className = 'fa fa-check';
                    window.setTimeout(function () {
                        icon.className = 'fa fa-clipboard';
                    }, 1500);
                });
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initDescriptionTabs();
        initSourceToggles();
        initUnchangedToggle();
        initCopyButtons();
    });
})();
